import { NgModule } from '@angular/core';
import { MatButtonModule, MatIconModule, MatTooltipModule } from '@angular/material';
import {MatListModule} from '@angular/material/list';
import { FuseNavigationModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import {RouterModule} from '@angular/router';
import { NavbarVerticalStyle1Component } from 'app/layout/components/navbar/vertical/style-1/style-1.component';
import { SubtraidSharedModule } from 'app/main/component/subtraidSharedModule';
import { JoyrideModule } from 'ngx-joyride';

@NgModule({
    declarations: [
        NavbarVerticalStyle1Component,
    ],
    imports     : [
        MatButtonModule,
        MatIconModule,
        MatListModule,
        SubtraidSharedModule,
        FuseSharedModule,
        FuseNavigationModule,
        RouterModule,
        MatTooltipModule,
        JoyrideModule.forChild()
    ],
    exports     : [
        NavbarVerticalStyle1Component
    ]
})
export class NavbarVerticalStyle1Module
{
}
